
define('text!templates/content/reports/cd_stocks.html',[],function () { return '<div class="panel panel-transparent">\n    <div class="panel-body">\n        <table class="cd-stocks-list table table-striped">\n\n        </table>\n    </div>\n</div>\n';});

